export default __webpack_public_path__ + "static/media/fad-preset-a.00d470cf.svg";